// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"70":"chunk-srdce-pro-vas-organizations","71":"chunk-srdce-pro-vas-organizations-carousel"}[chunkId] || chunkId) + "." + {"70":"d826368a94e3ca4a14f1","71":"2f60aef7e9b3af82d62a","80":"8888a0e0b553abb30487","84":"a9e93ca86228206e4dfc"}[chunkId] + ".js";
};